import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Paper,
    Toolbar,
    Typography,
    Link,
    Button,
    Grid,
    TextField,
    Snackbar,
    MenuItem,
} from '@material-ui/core'
import Segment from '../../components/Segment'
import { Link as RouterLink } from 'react-router-dom'
import SaveIcon from '@material-ui/icons/Save'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import MySnackbarContent from '../../components/MySnackbar'
// import { AddBox } from '@material-ui/icons'
import { services } from '../../redux/FeathersRedux'

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
})

const INITIAL_DATA = {
    name: '',
    lastName: '',
    role: '',
    email: '',
    password: '',
}

const ROLES_TYPES = [
	{
		label: 'Administrador',
		value: 'ADMIN'
	},
	// {
	// 	label: 'Técnico',
	// 	value: 'TECNICAL'
	// },
	{
		label: 'Supervisor',
		value: 'SUPERVISOR'
	},
	{
		label: 'Operador',
		value: 'OPERATOR'
	},
]

class UsersCreate extends Component {
    state = {
        loading: false,
        data: INITIAL_DATA,
        snackbar: {
            open: false,
            message: '',
            variant: 'success',
        },
    }

    /**
     * Set state for the current data
     */
    handleDataChange = name => (event) => {
        const { value } = event.target

        this.setState({
            data: {
                ...this.state.data,
                [name]: value,
            },
        })
    }

    checkDisabled = () => {
        const { name, lastName, role, email, password } = this.state.data

        return name === '' || lastName === '' || role === '' || email === '' || password === ''
    }

    /**
     * Enables Snackbar component which displays API response
     */
    openSnackbar = (message, variant) => {
        this.setState({
            snackbar: {
                open: true,
                message,
                variant,
            },
        })
    }

    /**
     * Closes Snackbar component
     */
    closeSnackbar = () => {
        this.setState({
            snackbar: {
                ...this.state.snackbar,
                open: false,
            },
        })
    }

    save = async () => {
        this.setState({ loading: true })
        this.props.usersCreate(this.state.data)
        .then(res => {
            console.log(res);
            this.openSnackbar('Guardo correctamente', 'success')
            this.setState({ loading: false, data: INITIAL_DATA })
        })
        .catch(err => {
            console.log(err);
            this.openSnackbar('Hubo un error al guardar', 'error')
            this.setState({ loading: false })
        })
    }

    renderToolbar = () => {
        const { classes } = this.props

        return (
            <Toolbar>
                <Typography variant="h6" style={{ flex: 1 }}>
                    <Link component={RouterLink} to="/users">
                        Usuarios
                    </Link>
                        {' > Crear'}
                </Typography>

                <Button
                    onClick={this.save}
                    size="small"
                    color="primary"
                    variant="contained"
                    disabled={this.checkDisabled()}
                >
                    <SaveIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                    Guardar
                </Button>
            </Toolbar>
        )
    }

    renderForm = () => {
        // const { classes } = this.props
        return (
            <form>
                <Grid container spacing={16} style={{ paddingLeft: 16, paddingRight: 16, paddingBottom: 16 }}>

                    <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="subtitle1" style={{ flex: 1 }}>
                            Datos personales
                        </Typography>
                    </Grid>
                    <Grid item xs={12} lg={4} md={4}>
                        <TextField
                            id="name"
                            label="Nombre"
                            value={this.state.data.name}
                            onChange={this.handleDataChange('name')}
                            margin="none"
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} lg={4} md={4}>
                        <TextField
                            id="lastName"
                            label="Apellido"
                            value={this.state.data.lastName}
                            onChange={this.handleDataChange('lastName')}
                            margin="none"
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} lg={4} md={4}>
                        <TextField
                            select
                            label="Rol"
                            variant="outlined"
                            fullWidth
                            value={this.state.data.role}
                            onChange={this.handleDataChange('role')}
                        >
                            {ROLES_TYPES.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="subtitle1" style={{ flex: 1 }}>
                            Datos de cuenta
                        </Typography>
                    </Grid>
                    <Grid item xs={12} lg={6} md={6}>
                        <TextField
                            id="email"
                            label="Correo Electrónico"
                            value={this.state.data.email}
                            onChange={this.handleDataChange('email')}
                            margin="none"
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} lg={6} md={6}>
                        <TextField
                            id="password"
                            label="Contraseña"
                            value={this.state.data.password}
                            onChange={this.handleDataChange('password')}
                            margin="none"
                            variant="outlined"
                            fullWidth
                            type="password"
                        />
                    </Grid>

                </Grid>

            </form>
        )
    }

    render() {
        return (
            <Paper>
                <this.renderToolbar />

                <Segment loading={this.state.loading}>
                    <this.renderForm />
                </Segment>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    open={this.state.snackbar.open}
                    autoHideDuration={10000}
                    onClose={this.closeSnackbar}
                >
                    <MySnackbarContent
                        message={this.state.snackbar.message}
                        variant={this.state.snackbar.variant}
                        onClose={this.closeSnackbar}
                    />
                </Snackbar>
            </Paper>
        )
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = (dispatch) => ({
    usersCreate: (user) => dispatch(services.users.create(user)),
})

export default withStyles(styles, {withTheme: true})(connect(
    mapStateToProps,
    mapDispatchToProps,
    )(UsersCreate))